import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {WeeeSystems} from '../../../models/weee_systems.interface';
import {UsersService} from '../../../services/users.service';
import {User} from '../../../../kf-data-entry/models/user.interface';
import {Role} from '../../../models/role.interface';

@Component({
  selector: 'app-create-users',
  templateUrl: './create-users.component.html',
  styleUrls: ['./create-users.component.scss']
})
export class CreateUsersComponent implements OnInit {

  userCreateForm = this.formBuilder.group({
    firstName: [''],
    name: ['', Validators.required],
    email: ['', Validators.required],
    function: [null],
    role: ['', Validators.required],
    weeeSystem: [null, Validators.required],
  });

  get firstNameControl(): FormControl {
    return this.userCreateForm.get('firstName') as FormControl;
  }
  get nameControl(): FormControl {
    return this.userCreateForm.get('name') as FormControl;
  }
  get emailControl(): FormControl {
    return this.userCreateForm.get('email') as FormControl;
  }
  get functionControl(): FormControl {
    return this.userCreateForm.get('function') as FormControl;
  }
  get weeeSystemControl(): FormControl {
    return this.userCreateForm.get('weeeSystem') as FormControl;
  }
  get roleControl(): FormControl {
    return this.userCreateForm.get('role') as FormControl;
  }

  @Output()
  createEvent: EventEmitter<void> = new EventEmitter<void>();

  constructor(private dialogRef: MatDialogRef<CreateUsersComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {weeeSystems: WeeeSystems[], roles: Role[]},
              private readonly formBuilder: FormBuilder,
              private readonly usersService: UsersService) { }

  ngOnInit(): void {
  }

  sendCreationRequest(): void {
    const dto: User | null = this.getCreationDto();
    if (dto) {
      this.usersService.createUser(dto).subscribe(
        () => {
          this.createEvent.emit();
          this.closeDialog();
        },
        () => {
          this.closeDialog();
        }
      );
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  private getCreationDto(): User {
    let role: Role =  {code: '', description: '', id: 0, name: ''};
    this.data.roles.forEach(r => {
      if (this.roleControl.value === r.code) {
        role = r;
      }
    });
    return {
      email: this.emailControl.value,
      name: this.nameControl.value,
      firstName: this.firstNameControl.value,
      userFunction: this.functionControl.value,
      role,
      weeeSystem: this.roleControl.value !== 'WF_ADMIN' ? this.weeeSystemControl.value : null
    };
  }

}
